import yn from 'yn';
import { datadogLogs } from '@datadog/browser-logs';
import { formatUIEventParams, formatUser, applyExperiments } from '../src/client/util/tracking';
import {
    formatUIEventParamsLegacy,
    formatActor,
} from '../src/client/util/trackingLegacy';
import { promiseTimeout } from '../src/client/util/promise';
import { isInternalUrl } from '../src/client/vNext/helpers/routing/isInternalUrl';
import { trackingAttributesMapping } from './events/engagement';
import { selectors } from '../src/client/redux/authentication';

const findLinkParent = (element) => {
    while (element) {
        if ((element.nodeName || element.tagName).toLowerCase() === 'a') {
            return element;
        }
        element = element.parentNode; // eslint-disable-line no-param-reassign
    }
    return null;
};

const findButtonParent = (element) => {
    while (element) {
        if ((element.nodeName || element.tagName).toLowerCase() === 'button') {
            return element;
        }
        element = element.parentNode; // eslint-disable-line no-param-reassign
    }
    return null;
};

let currentClickHandler = null;

export default (tracker, getState) => {
    const { externalLink } = trackingAttributesMapping.mypage;
    const trackEvent = async (payload) => {
        const state = getState();
        const isTpaasEnabled = selectors.getIsTpaasEnabled(state);

        const legacyPayload = formatUIEventParamsLegacy(payload);

        if (selectors.isUserAuthenticated(state)) {
            legacyPayload.actor = formatActor(state);
        }

        applyExperiments(state);

        await promiseTimeout(tracker.track('trackerEvent', legacyPayload));

        if (isTpaasEnabled) {
            const eventPayload = {
                ...formatUIEventParams(payload),
            };

            if (selectors.isUserAuthenticated(state)) {
                const user = formatUser(state);
                if (user) eventPayload.user = user;
            }

            await promiseTimeout(tracker.trackEngagementUIElement(eventPayload));
        }
    };

    if (currentClickHandler) {
        document.removeEventListener('click', currentClickHandler);
    }

    const clickHandler = async (event) => {
        const target = event.target || event.srcElement;
        const linkTarget = findLinkParent(target);
        const buttonTarget = findButtonParent(target);

        if (!linkTarget) {
            return;
        }

        const isInternal = yn(linkTarget.dataset.internal);
        const isAutoTrackerEnabled = !yn(linkTarget.dataset.disableAutoTracker);
        const isTheSameHref = window.location.href === linkTarget.href;

        if (buttonTarget || isInternal || !isAutoTrackerEnabled) {
            return;
        }

        if (linkTarget.target !== '_blank') {
            event.preventDefault();
        }
        const isExternal = !isInternalUrl(linkTarget.getAttribute('href'));
        try {
            if (linkTarget.dataset.trackingId) {
                await trackEvent({
                    id: linkTarget.dataset.trackingId,
                    url: linkTarget.href,
                    elementType: 'Link',
                });
            } else if (isExternal) {
                await trackEvent({
                    id: externalLink,
                    url: linkTarget.href,
                    elementType: 'Link',
                });
            }
        } catch (err) {
            datadogLogs.logger.warn('AutoTracking - track error',
                {
                    id: linkTarget.dataset.trackingId,
                    url: linkTarget.href,
                },
                err);
        }

        if (linkTarget.target !== '_blank' && !isTheSameHref) {
            window.location.assign(linkTarget.href);
        }
    };

    document.addEventListener('click', clickHandler);
    currentClickHandler = clickHandler;

    return () => {
        if (currentClickHandler === clickHandler) {
            document.removeEventListener('click', clickHandler);
            currentClickHandler = null;
        }
    };
};
